/**
 * Shortens a full Nominatim address to a concise display format.
 * "123 Main St, Middleton, Ada County, Idaho, 83644, United States"
 * → "123 Main St, Middleton, ID"
 */
export function shortenAddress(location: string): string {
  if (!location || location === 'TBD') return location;
  const US_STATES: Record<string, string> = {
    'alabama': 'AL', 'alaska': 'AK', 'arizona': 'AZ', 'arkansas': 'AR', 'california': 'CA',
    'colorado': 'CO', 'connecticut': 'CT', 'delaware': 'DE', 'florida': 'FL', 'georgia': 'GA',
    'hawaii': 'HI', 'idaho': 'ID', 'illinois': 'IL', 'indiana': 'IN', 'iowa': 'IA',
    'kansas': 'KS', 'kentucky': 'KY', 'louisiana': 'LA', 'maine': 'ME', 'maryland': 'MD',
    'massachusetts': 'MA', 'michigan': 'MI', 'minnesota': 'MN', 'mississippi': 'MS',
    'missouri': 'MO', 'montana': 'MT', 'nebraska': 'NE', 'nevada': 'NV', 'new hampshire': 'NH',
    'new jersey': 'NJ', 'new mexico': 'NM', 'new york': 'NY', 'north carolina': 'NC',
    'north dakota': 'ND', 'ohio': 'OH', 'oklahoma': 'OK', 'oregon': 'OR', 'pennsylvania': 'PA',
    'rhode island': 'RI', 'south carolina': 'SC', 'south dakota': 'SD', 'tennessee': 'TN',
    'texas': 'TX', 'utah': 'UT', 'vermont': 'VT', 'virginia': 'VA', 'washington': 'WA',
    'west virginia': 'WV', 'wisconsin': 'WI', 'wyoming': 'WY',
  };
  const parts = location.split(',').map(p => p.trim());
  if (parts.length <= 2) return location;
  // Find the state part and abbreviate it
  let stateAbbr = '';
  let stateIdx = -1;
  for (let i = 0; i < parts.length; i++) {
    const lower = parts[i].toLowerCase();
    if (US_STATES[lower]) {
      stateAbbr = US_STATES[lower];
      stateIdx = i;
      break;
    }
  }
  // Nominatim format: "street, city, county, state, zip, country"
  // We want: "street, city, STATE"
  if (stateIdx >= 2) {
    return `${parts[0]}, ${parts[1]}, ${stateAbbr}`;
  }
  if (stateIdx === 1) {
    return `${parts[0]}, ${stateAbbr}`;
  }
  // Fallback: take first 3 parts
  return parts.slice(0, 3).join(', ');
}
